import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HandleError,HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { ApplicationVO } from '../../admin-users/models/application';
import { ApplicationProfilesVO, ProfilePermissionXrefVO, ProfileResponse } from '../models/applicationProfile';
import { ProfileSearchVO } from '../models/profile.model';

@Injectable()
export class ProfileService {
    public applicationProfile:ApplicationProfilesVO;
   public application:ApplicationVO;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    public profileSearchVO: ProfileSearchVO;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('ProfileService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    profileInfoInit() {
        this.applicationProfile = new ApplicationProfilesVO();
        this.application= new ApplicationVO();
    }




    getProfileListCount(profileSearchVO: ProfileSearchVO): Observable<number> {
        return this._http.post<any>(
            environment.getProfileListCountUrl, profileSearchVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('getProfileListCount', []))
            );
    }



    getAllProfileList(profileSearchVO: ProfileSearchVO): Observable<any> {
        return this._http.post<any>(
            environment.getAllProfileListUrl, profileSearchVO, this.httpOptions)
            .pipe(catchError(this.handleError('getAllProfileList', [])));
    }
    getProfileInfoById(id: number,userName:string): Observable<ProfileResponse> {
        return this._http.get<any>(
            environment.profileinfoByIdUrl + id+"?username="+userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getProfileInfoById', []))
            );

    }

    postProfilePermissionXrefInfo(profileVO: ProfilePermissionXrefVO[]): Observable<ProfilePermissionXrefVO[]> {
        return this._http.post<ProfilePermissionXrefVO[]>(
            
            environment.postProfilePermissionUrl, profileVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('postProfilePermissionXrefInfo', []))
            );
    }

    postProfileInfo(profileVO: ApplicationProfilesVO): Observable<ApplicationProfilesVO[]> {
        return this._http.post<ApplicationProfilesVO[]>(
            
            environment.postProfileUrl, profileVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('postProfilePermissionXrefInfo', []))
            );
    }
    DeleteProfileInfoById(profileId: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.deleteProfileInfoByIdUrl + profileId + "?username=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deleteRoleInfoById', []))
            );

    }

    updateProfileDetails(profileVO: ApplicationProfilesVO): Observable<ApiResponse> {
        return this._http.post<any>(
            environment.updateProfileUrl, profileVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('postProfilePermissionXrefInfo', []))
            );
    }

}